export default {
    title: '面试满意度问卷',
    abnormal_404: '你要访问的页面不见了……',
    abnormal_404_sub: '请检查网址是否正确',
    submit: '提交',
    requiredError: '此问题为必填',
    reasonRequiredError: '请输入内容',
    multiSelect: '（多选）',
    submitted: '你已提交过此问卷',
    submittedTime: '提交时间：{time}',
    expired: '问卷已失效',
    success: '感谢你的反馈',
    pleaseEnter: '请输入',
    pleaseSupplementExplanation: '请补充说明',

    // 请求失败抛出错误
    MessageNetworkError: '网络出现问题，请稍后重试',
    MessageHttpError: '系统出现问题，请稍后重试',
    MessageNetworkDisconnected: '网络断开，请检查网络连接'
};
